import { clearUserProfileLoader } from 'src/api/userProfileLoader';

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

/** Normalize login/refresh API payloads (flat or `{ data: { ... } }`). */
export const extractAuthTokens = (payload: unknown): AuthTokens | null => {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const record = payload as Record<string, unknown>;
  const source =
    record.data && typeof record.data === 'object'
      ? (record.data as Record<string, unknown>)
      : record;

  const { accessToken } = source;
  const { refreshToken } = source;

  if (typeof accessToken !== 'string' || typeof refreshToken !== 'string') {
    return null;
  }

  if (!accessToken.length || !refreshToken.length) {
    return null;
  }

  return { accessToken, refreshToken };
};

export const persistAuthTokens = (tokens: AuthTokens): void => {
  localStorage.setItem('accessToken', tokens.accessToken);
  localStorage.setItem('refreshToken', tokens.refreshToken);
};

export const clearAuthSessionStorage = (): void => {
  clearUserProfileLoader();
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('white_label');
  localStorage.removeItem('organizationId');
  localStorage.removeItem('is2FAEnabled');
  localStorage.removeItem('isOtpVerified');
  localStorage.removeItem('isQrVerified');
  localStorage.removeItem('_te');
  localStorage.removeItem('_tp');
  localStorage.removeItem('qrCode');
};
